import { ButtonsRight } from '../../../../interfaces/UI'
import { usePublication } from '../../../../hooks/usePublication';
import { AuthorCard } from './AuthorCard';
import { useUi } from '../../../../hooks';

interface Props {
  openButtons : ButtonsRight,
  setOpenButtons :  (button : ButtonsRight) => void
}

export const Authors = ({ openButtons, setOpenButtons }: Props) => {
  const {publication, path} = usePublication();
  const { isOpenSideBar, optionSidebarOpen, handleToggleSidebar } = useUi();

  return (
    <div id="option-9" className={`aside__content ${openButtons.optAuthor?"active":""}`}>
      <div className="aside__content-header">
        <h3>Autores</h3>
        <button className="btn btn-rounded btn-rounded-transparent btn-close" onClick={() => {
          setOpenButtons({...openButtons, optAuthor: false})
        }}>
          <span className="btn__icon"><i className="icon icon-vpro-close"></i></span>
        </button>
      </div>
      <div className="aside__content-data main-sb">
        {
          publication.authors?.map(author => (
            <AuthorCard key={author.name} author={author}/>
          ))
        }
      </div>
    </div>
  )
}